function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormItemWrapper from './form-item-wrapper';
import emitter from '@/utils/emitter';
import i18n, { translate } from '@/utils/i18n';
import fieldMixin from '@/components/form-designer/form-widget/field-widget/fieldMixin';
import { clientConfigLabelApi } from '@/api/enterprise';
import { deepClone } from '@/utils/util';
export default {
  name: 'tag-widget',
  componentName: 'FieldWidget',
  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,
    designState: {
      type: Boolean,
      default: false
    },
    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */type: String,
      default: ''
    }
  },
  components: {
    FormItemWrapper: FormItemWrapper,
    selectLabel: function selectLabel() {
      return import('@/components/form-common/select-label');
    }
  },
  inject: ['refList', 'formConfig', 'globalOptionData', 'globalModel'],
  data: function data() {
    return {
      oldFieldValue: null,
      //field组件change之前的值
      fieldModel: null,
      rules: [],
      tableData: [],
      labelData: [],
      labelList: [] // 选中的标签列表
    };
  },
  computed: {
    allowDefaultFirstOption: function allowDefaultFirstOption() {
      return !!this.field.options.filterable && !!this.field.options.allowCreate;
    },
    remoteMethod: function remoteMethod() {
      if (!!this.field.options.remote && !!this.field.options.onRemoteQuery) {
        return this.remoteQuery;
      } else {
        return undefined;
      }
    },
    contentForReadMode: function contentForReadMode() {
      function getNamesByIds(data, ids) {
        if (!ids.length) {
          return '';
        }
        var names = [];
        var _iterator = _createForOfIteratorHelper(ids),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var id = _step.value;
            traverse(data, id);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        function traverse(items, id) {
          var name;
          var _iterator2 = _createForOfIteratorHelper(items),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              if (item.id === id) {
                name = item.name;
                var obj = {
                  id: item.id,
                  name: name
                };
                // this.labelList.push(obj)
                names.push(name);
                return;
              }
              if (item.child && item.child.length) {
                traverse(item.child, id);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        return names;
      }
      return getNamesByIds(this.labelData, this.fieldModel);
    }
  },
  beforeCreate: function beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },
  created: function created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.initOptionItems();
    this.initFieldModel();
    this.registerToRefList();
    this.initEventHandler();
    this.buildFieldRules();
    this.handleOnCreated();
    this.getTableData();
  },
  mounted: function mounted() {
    this.handleOnMounted();
  },
  beforeDestroy: function beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {
    handleFocusCustomEvent: function handleFocusCustomEvent(event) {
      if (this.getReadMode()) return;
      this.$refs.selectLabel.handlePopoverShow();
      this.oldFieldValue = deepClone(this.fieldModel);
    },
    // 选中客户标签成功回调
    handleLabelConf: function handleLabelConf(res) {
      this.fieldModel = res.ids;
      this.labelList = res.list;
      /* input的清除输入小按钮会同时触发handleChangeEvent、handleInputCustomEvent！！ */
      this.syncUpdateFormModel(this.fieldModel);
      this.emitFieldDataChange(this.fieldModel, this.oldFieldValue);

      //number组件一般不会触发focus事件，故此处需要手工赋值oldFieldValue！！
      this.oldFieldValue = deepClone(this.fieldModel); /* oldFieldValue需要在initFieldModel()方法中赋初值!! */

      /* 主动触发表单的单个字段校验，用于清除字段可能存在的校验错误提示 */
      this.dispatch('VFormRender', 'fieldValidation', [this.getPropName()]);
    },
    // 列表
    getTableData: function getTableData() {
      var _this = this;
      if (this.field.options.optionItems && this.field.options.optionItems.length == 0) {
        this.getLabelData();
      } else {
        this.tableData = this.field.options.optionItems;
        if (this.tableData && this.tableData.length > 0) {
          this.tableData.map(function (value) {
            if (value.children && value.children.length > 0) {
              value.children.map(function (val) {
                _this.labelData.push(val);
              });
            }
          });
        }
      }
    },
    getLabelData: function getLabelData() {
      var _this2 = this;
      var data = {
        page: 0,
        limit: 0
      };
      clientConfigLabelApi(data).then(function (res) {
        _this2.tableData = res.data.list === undefined ? [] : res.data.list;
        if (_this2.tableData && _this2.tableData.length > 0) {
          _this2.tableData.map(function (value) {
            if (value.children.length > 0) {
              value.children.map(function (val) {
                _this2.labelData.push(val);
              });
            }
          });
        }
      });
    }
  }
};